<template>
  <div
    :class="{[size]: size}"
    class="share-panel"
  >
    <div
      v-if="size !== 'size-mini'"
      class="title-close"
    >
      <!-- <h2>Share</h2> -->

      <button @click="hideShare">Close</button>
    </div>

    <div class="artwork-meta">
      <Artwork />
      <MetaInfo />
    </div>

    <div class="share-recast">
      <LinkShare />
    </div>

    <div
      v-if="size !== 'size-mini'"
      class="social-more"
    >
      <ul>
        <li>
          <a
            :href="facebookUrl"
            target="simplecast"
          ><IconFacebook /></a>
        </li>
        <li>
          <a
            :href="twitterUrl"
            target="simplecast"
          ><IconTwitter /></a>
        </li>
        <li>
          <a
            :href="emailUrl"
            target="simplecast"
          ><IconEmail /></a>
        </li>
      </ul>
      <!-- <a href="#more-options">More Options</a> -->
    </div>
  </div>
</template>

<script>
import Artwork from './Artwork'
import IconEmail from '../assets/svg/email.svg'
import IconFacebook from '../assets/svg/facebook.svg'
import IconTwitter from '../assets/svg/twitter.svg'
import MetaInfo from './MetaInfo'
import LinkShare from './LinkShare'
import Store from '../store'

export default {
  components: {
    Artwork,
    IconEmail,
    IconFacebook,
    IconTwitter,
    LinkShare,
    MetaInfo
  },
  data () { return { store: Store } },
  computed: {
    emailUrl () {
      let subject = 'Thought you might like to listen!'
      let body = `I’m listening to ${this.store.state.podcast.title} and thought you might like it! Listen here: ${this.shareUrl}`

      return `mailto:?&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
    },
    facebookUrl () {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`
    },
    shareUrl () {
      return `https://simplecast.com/s/${this.uid}`
    },
    size () { return this.store.state.size },
    twitterUrl () {
      let text = `Have you listened to ${this.store.state.podcast.title} yet? Check it out here: ${this.shareUrl}`

      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`
    },
    uid () {
      return this.store.state.episode.legacy_token || this.store.state.episode.id
    }
  },
  methods: {
    hideShare () {
      this.store.setShowShare(false)
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.share-panel {
  .meta-info {
    h1 {
      @include font-s-embed(700);
    }
    h2 {
     @include font-xxs();
    }
  }
  // MINI PLAYER STYLES
  &.size-mini {
    .meta-info {
      h2 {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.share-panel {
  background: $grey-200;
  border: solid 2px $grey-300;
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  padding: 10px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;

  // MINI PLAYER STYLES
  &.size-mini {
    background: transparent;
    border: none;
    flex-direction: row;
    left: 42px;
    padding: 8px 10px;
    width: calc(100% - 90px;

    .artwork-meta {
      background: transparent;
      border: none;
      flex: 1;
      margin: 0;
      padding: 0;

      .artwork {
        height: 36px;
        width: 36px;
      }
      .meta-info {
        flex: 1;
      }
    }
    .share-recast {
      margin-bottom: 0;

      .link-share {
        margin-right: 0;

        @include font-s();
      }
    }
  }
}
.title-close {
  display: block;
  margin-bottom: 12px;
  text-align: right;

  h2 {
    flex: 1;
    margin: 0;

    @include font-m-embed(700);
  }
  button {
    background: transparent;
    border: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
    text-transform: uppercase;

    @include font-xs();
  }
  h2,
  button {
    line-height: 14px;
  }
}
.artwork-meta {
  background: $white-000;
  border-radius: 2px;
  border: solid 1px $grey-400;
  display: flex;
  margin-bottom: 12px;
  padding: 6px;

  .artwork {
    margin-right: 10px;
    width: 42px;
  }
  .meta-info {
    align-self: center;
  }
}
.share-recast {
  display: flex;
  margin-bottom: 12px;

  .link-share {
    margin-right: 12px;
  }
  .link-recast,
  .link-share {
    flex-basis: 50%;
  }
}
.social-more {
  align-items: flex-end;
  display: flex;
  flex: 1;

  ul {
    align-items: center;
    display: flex;
    flex: 1;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  a {
    color: $black-800;
    text-transform: uppercase;

    @include font-s(700);
  }
}
</style>
